import React from 'react';
import PropTypes from 'prop-types';

const LeftArrowIcon = ({ className }) => {
    return (
        <svg
            width="10"
            height="12"
            viewBox="0 0 10 16"
            xmlns="http://www.w3.org/2000/svg"
            className={`stroke-current ${className}`}
            fill="none" // Remove fill to prevent conflicts
        >
            <path 
                d="M7.99902 2L1.99902 8L7.99902 14" 
                strokeWidth="2.432" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    );
};

LeftArrowIcon.propTypes = {
    className: PropTypes.string,
};

LeftArrowIcon.defaultProps = {
    className: '',
};

export default LeftArrowIcon;
